import * as shvl from 'shvl'
import en from '../../locales/en.default.json'

import type { Locale } from '@/types'

const LOCALES = {
  en,
  es: undefined
}

export const loadLocale = async (locale: string) => {
  if (!LOCALES[locale]) {
    LOCALES[locale] = await import(`../../locales/${locale === 'en' ? 'en.default' : locale}.json`)
  }
}

const interpolate = (string: string, values = {}) => {
  Object.entries(values).forEach(([ key, value ]: [ string, any ]) => {
    const regex = new RegExp(`{{ *${key} *}}`, 'g')
    string = string.replace(regex, String(value))
  })
  return string
}

export const translation = (key: string, locale: Locale, values = {}) => {
  const missing = `[translation missing]: ${key}`
  try {
    const obj = LOCALES[locale]
    const string = shvl.get(obj, key, missing)
    return interpolate(string, values)
  } catch {
    console.warn(missing)
    return missing
  }
}
